<div class="lead-table">
    <table class="table table-striped table-hover table-bordered" id="leadTable">
        <thead>
            <tr>
                <th class="col-options"></th>
                <th class="col-nome">Nome</th>
                <th class="col-origem">Origem</th>
                <th class="col-nome-campanha">Campanha de Origem</th>
                <th class="col-nome-campanha">Campanha de Qualificação</th>
                <th class="col-canal-midia-social">Canal</th>
                <th class="col-temperatura">Temperatura</th>
                <th class="col-email">E-mail</th>
                <th class="col-telefone">Telefone</th>
                <th class="col-celular">Celular</th>
                <th class="col-nome-cidade">Cidade</th>
                <th class="col-uf-estado">UF</th>
                <th class="col-nome-usuario-responsavel">Responsável</th>
            </tr>
        </thead>
        <tfoot>
            <tr>
                <td colspan="13" class="text-center">
                    {{total?.quantidadeLeads | decimalFormat: 1:0:0}} lead(s)
                </td>
            </tr>
        </tfoot>
    </table>         
</div>
